import { apiCall } from './gqlClient';

const GETMEMBERSHIPS_QUERY = `
  query getMemberships($groupId: Int) {
    getMemberships(groupId: $groupId)
    {
      id
			svcGroupId
			providerId
			name
			description
			price
			sessionsCounter
			reservationsCounter
			subscriptionsCounter
			alwaysAvailable
			duration
			durationType
			durationMonths
			isRecurringPayment
			isPublished
			startTime
			endTime
			membershipType
			allInclusive
			membershipTypeIds
			userHasMembership
			orderIndex
			walkinEmail
			rules
      ...fragments
    }
  }`;

export const getMembershipsApiCall = async ({groupId}, fragments = null) => apiCall({ query: GETMEMBERSHIPS_QUERY, variables: {groupId}, fragments });

const GETSINGLEMEMBERSHIPDETAILS_QUERY = `
  query getSingleMembershipDetails($id: Int!) {
    getSingleMembershipDetails(id: $id)
    {
      id
			svcGroupId
			providerId
			name
			description
			price
			sessionsCounter
			reservationsCounter
			subscriptionsCounter
			alwaysAvailable
			duration
			durationType
			durationMonths
			isRecurringPayment
			isPublished
			startTime
			endTime
			membershipType
			allInclusive
			membershipTypeIds
			userHasMembership
			orderIndex
			walkinEmail
			rules
      ...fragments
    }
  }`;

export const getSingleMembershipDetailsApiCall = async ({id}, fragments = null) => apiCall({ query: GETSINGLEMEMBERSHIPDETAILS_QUERY, variables: {id}, fragments });

const GETARCHIVEDMEMBERSHIPS_QUERY = `
  query getArchivedMemberships {
    getArchivedMemberships
    {
      id
			svcGroupId
			providerId
			name
			description
			price
			sessionsCounter
			reservationsCounter
			subscriptionsCounter
			alwaysAvailable
			duration
			durationType
			durationMonths
			isRecurringPayment
			isPublished
			startTime
			endTime
			membershipType
			allInclusive
			membershipTypeIds
			userHasMembership
			orderIndex
			walkinEmail
			rules
      ...fragments
    }
  }`;

export const getArchivedMembershipsApiCall = async (fragments = null) => apiCall({ query: GETARCHIVEDMEMBERSHIPS_QUERY, variables: {}, fragments });

const GETUSERMEMBERSHIPS_QUERY = `
  query getUserMemberships($userId: Int, $all: Boolean, $customerId: Int) {
    getUserMemberships(userId: $userId, all: $all, customerId: $customerId)
    {
      id
			userId
			membershipId
			sessionsCounter
			reservationsCounter
			membershipType
			membershipTypeIds
			allInclusive
			isActive
			startTime
			endTime
			describedName
			subscriptionsCounter
			usedSessions
			bookedSessions
			bookedReservations
			usedReservations
			totalSessionsCounter
			totalReservationsCounter
			price
			customerId
			rules
			isRequested
			userBundleId
			bundleName
			bundleId
			bundleDescription
			bundlePrice
			bundleDuration
			bundleDurationType
			bundleGroupName
			bundleGroupColor
      ...fragments
    }
  }`;

export const getUserMembershipsApiCall = async ({userId, all, customerId}, fragments = null) => apiCall({ query: GETUSERMEMBERSHIPS_QUERY, variables: {userId, all, customerId}, fragments });

const GETMYMEMBERSHIPS_QUERY = `
  query getMyMemberships($all: Boolean) {
    getMyMemberships(all: $all)
    {
      id
			userId
			membershipId
			sessionsCounter
			reservationsCounter
			membershipType
			membershipTypeIds
			allInclusive
			isActive
			startTime
			endTime
			describedName
			subscriptionsCounter
			usedSessions
			bookedSessions
			bookedReservations
			usedReservations
			totalSessionsCounter
			totalReservationsCounter
			price
			customerId
			rules
			isRequested
			userBundleId
			bundleName
			bundleId
			bundleDescription
			bundlePrice
			bundleDuration
			bundleDurationType
			bundleGroupName
			bundleGroupColor
      ...fragments
    }
  }`;

export const getMyMembershipsApiCall = async ({all}, fragments = null) => apiCall({ query: GETMYMEMBERSHIPS_QUERY, variables: {all}, fragments });

const GETMYENTITLEMENTSNOW_QUERY = `
  query getMyEntitlementsNow {
    getMyEntitlementsNow
    {
      userMembershipId
			membershipId
			membershipName
			membershipType
			domain
			providerId
			providerName
			bundleName
			startTime
			endTime
      ...fragments
    }
  }`;

export const getMyEntitlementsNowApiCall = async (fragments = null) => apiCall({ query: GETMYENTITLEMENTSNOW_QUERY, variables: {}, fragments });

const GETPROVIDERMEMBERSHIPS_QUERY = `
  query getProviderMemberships($membershipId: Int) {
    getProviderMemberships(membershipId: $membershipId)
    {
      id
			userId
			membershipId
			sessionsCounter
			reservationsCounter
			membershipType
			membershipTypeIds
			allInclusive
			isActive
			startTime
			endTime
			describedName
			subscriptionsCounter
			usedSessions
			bookedSessions
			bookedReservations
			usedReservations
			totalSessionsCounter
			totalReservationsCounter
			price
			customerId
			rules
			isRequested
			userBundleId
			bundleName
			bundleId
			bundleDescription
			bundlePrice
			bundleDuration
			bundleDurationType
			bundleGroupName
			bundleGroupColor
      ...fragments
    }
  }`;

export const getProviderMembershipsApiCall = async ({membershipId}, fragments = null) => apiCall({ query: GETPROVIDERMEMBERSHIPS_QUERY, variables: {membershipId}, fragments });

const CHECKMEMBERSHIP_QUERY = `
  query checkMembership($serviceId: Int!, $providerId: Int!, $serviceType: String!) {
    checkMembership(serviceId: $serviceId, providerId: $providerId, serviceType: $serviceType)
    {
      onlinePayments
			serviceHasMembership
			userHasMembership
      ...fragments
    }
  }`;

export const checkMembershipApiCall = async ({serviceId, providerId, serviceType}, fragments = null) => apiCall({ query: CHECKMEMBERSHIP_QUERY, variables: {serviceId, providerId, serviceType}, fragments });

const CHECKMEMBERSHIPBYOWNER_QUERY = `
  query checkMembershipByOwner($userId: Int, $serviceId: Int, $serviceType: String, $customerId: Int) {
    checkMembershipByOwner(userId: $userId, serviceId: $serviceId, serviceType: $serviceType, customerId: $customerId)
    {
      onlinePayments
			serviceHasMembership
			userHasMembership
      ...fragments
    }
  }`;

export const checkMembershipByOwnerApiCall = async ({userId, serviceId, serviceType, customerId}, fragments = null) => apiCall({ query: CHECKMEMBERSHIPBYOWNER_QUERY, variables: {userId, serviceId, serviceType, customerId}, fragments });

const GETAVAILABLEMEMBERSHIPSFORMULTIPLERESERVATIONS_QUERY = `
  query getAvailableMembershipsForMultipleReservations($serviceId: Int!, $beginDate: DateTime!, $endDate: DateTime, $userId: Int, $customerId: Int) {
    getAvailableMembershipsForMultipleReservations(serviceId: $serviceId, beginDate: $beginDate, endDate: $endDate, userId: $userId, customerId: $customerId)
    {
      onlinePayments
			serviceHasMembership
			userHasMembership
      ...fragments
    }
  }`;

export const getAvailableMembershipsForMultipleReservationsApiCall = async ({serviceId, beginDate, endDate, userId, customerId}, fragments = null) => apiCall({ query: GETAVAILABLEMEMBERSHIPSFORMULTIPLERESERVATIONS_QUERY, variables: {serviceId, beginDate, endDate, userId, customerId}, fragments });

const CHECKMEMBERSHIPBYOWNERBYORDERID_QUERY = `
  query checkMembershipByOwnerByOrderId($orderId: Int!, $serviceId: Int!) {
    checkMembershipByOwnerByOrderId(orderId: $orderId, serviceId: $serviceId)
    {
      onlinePayments
			serviceHasMembership
			userHasMembership
      ...fragments
    }
  }`;

export const checkMembershipByOwnerByOrderIdApiCall = async ({orderId, serviceId}, fragments = null) => apiCall({ query: CHECKMEMBERSHIPBYOWNERBYORDERID_QUERY, variables: {orderId, serviceId}, fragments });

const CHECKMEMBERSHIPBYOWNERFORSERVICE_QUERY = `
  query checkMembershipByOwnerForService($serviceId: Int!, $date: DateTime!, $userId: Int, $customerId: Int) {
    checkMembershipByOwnerForService(serviceId: $serviceId, date: $date, userId: $userId, customerId: $customerId)
  }`;

export const checkMembershipByOwnerForServiceApiCall = async ({serviceId, date, userId, customerId}, ) => apiCall({ query: CHECKMEMBERSHIPBYOWNERFORSERVICE_QUERY, variables: {serviceId, date, userId, customerId}});

const GETALLBOOKINGSFORMEMBERSHIP_QUERY = `
  query getAllBookingsForMembership($id: Int!) {
    getAllBookingsForMembership(id: $id)
  }`;

export const getAllBookingsForMembershipApiCall = async ({id}, ) => apiCall({ query: GETALLBOOKINGSFORMEMBERSHIP_QUERY, variables: {id}});

const GETMEMBERSHIPRULES_QUERY = `
  query getMembershipRules {
    getMembershipRules
    {
      id
			providerId
			name
			type
			period
			amount
			timeFrom
			timeTo
			daysOfWeek
      ...fragments
    }
  }`;

export const getMembershipRulesApiCall = async (fragments = null) => apiCall({ query: GETMEMBERSHIPRULES_QUERY, variables: {}, fragments });

const GETTOTALBUNDLEPRICEFORUSER_QUERY = `
  query getTotalBundlePriceForUser($userId: Int, $customerId: Int) {
    getTotalBundlePriceForUser(userId: $userId, customerId: $customerId)
  }`;

export const getTotalBundlePriceForUserApiCall = async ({userId, customerId}, ) => apiCall({ query: GETTOTALBUNDLEPRICEFORUSER_QUERY, variables: {userId, customerId}});

const GETUSERMEMBERSHIPSBYMEMBERSHIPID_QUERY = `
  query getUserMembershipsByMembershipId($membershipId: Int!) {
    getUserMembershipsByMembershipId(membershipId: $membershipId)
  }`;

export const getUserMembershipsByMembershipIdApiCall = async ({membershipId}, ) => apiCall({ query: GETUSERMEMBERSHIPSBYMEMBERSHIPID_QUERY, variables: {membershipId}});

const GETMEMBERSHIPSWITHRULES_QUERY = `
  query getMembershipsWithRules($includeAccess: Boolean) {
    getMembershipsWithRules(includeAccess: $includeAccess)
    {
      id
			svcGroupId
			providerId
			name
			description
			price
			sessionsCounter
			reservationsCounter
			subscriptionsCounter
			alwaysAvailable
			duration
			durationType
			durationMonths
			isRecurringPayment
			isPublished
			startTime
			endTime
			membershipType
			domain
			allInclusive
			membershipTypeIds
			userHasMembership
			orderIndex
			walkinEmail
			isPrimary
			rules
      ...fragments
    }
  }`;

export const getMembershipsWithRulesApiCall = async ({includeAccess}, fragments = null) => apiCall({ query: GETMEMBERSHIPSWITHRULES_QUERY, variables: {includeAccess}, fragments });

const ARCHIVEMEMBERSHIP_QUERY = `
  mutation archiveMembership($id: Int!) {
    archiveMembership(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const archiveMembershipApiCall = async ({id}, fragments = null) => apiCall({ query: ARCHIVEMEMBERSHIP_QUERY, variables: {id}, fragments });

const RESTOREMEMBERSHIP_QUERY = `
  mutation restoreMembership($id: Int!) {
    restoreMembership(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const restoreMembershipApiCall = async ({id}, fragments = null) => apiCall({ query: RESTOREMEMBERSHIP_QUERY, variables: {id}, fragments });

const SAVEMEMBERSHIP_QUERY = `
  mutation saveMembership($name: String!, $description: String!, $price: Float!, $sessionsCounter: Int!, $reservationsCounter: Int!, $membershipType: String!, $svcGroupId: Int!, $membershipTypeIds: String, $startTime: DateTime, $endTime: DateTime, $isPublished: Boolean, $duration: Int, $durationType: String, $allInclusive: Boolean, $id: Int, $alwaysAvailable: Boolean, $rules: String, $propagatedUserMemberships: [String], $isPrimary: Boolean, $domain: String) {
    saveMembership(name: $name, description: $description, price: $price, sessionsCounter: $sessionsCounter, reservationsCounter: $reservationsCounter, membershipType: $membershipType, svcGroupId: $svcGroupId, membershipTypeIds: $membershipTypeIds, startTime: $startTime, endTime: $endTime, isPublished: $isPublished, duration: $duration, durationType: $durationType, allInclusive: $allInclusive, id: $id, alwaysAvailable: $alwaysAvailable, rules: $rules, propagatedUserMemberships: $propagatedUserMemberships, isPrimary: $isPrimary, domain: $domain)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const saveMembershipApiCall = async ({name, description, price, sessionsCounter, reservationsCounter, membershipType, svcGroupId, membershipTypeIds, startTime, endTime, isPublished, duration, durationType, allInclusive, id, alwaysAvailable, rules, propagatedUserMemberships, isPrimary, domain}, fragments = null) => apiCall({ query: SAVEMEMBERSHIP_QUERY, variables: {name, description, price, sessionsCounter, reservationsCounter, membershipType, svcGroupId, membershipTypeIds, startTime, endTime, isPublished, duration, durationType, allInclusive, id, alwaysAvailable, rules, propagatedUserMemberships, isPrimary, domain}, fragments });

const TOGGLEMEMBERSHIPSTATUS_QUERY = `
  mutation toggleMembershipStatus($id: Int!, $isPublished: Boolean!) {
    toggleMembershipStatus(id: $id, isPublished: $isPublished)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const toggleMembershipStatusApiCall = async ({id, isPublished}, fragments = null) => apiCall({ query: TOGGLEMEMBERSHIPSTATUS_QUERY, variables: {id, isPublished}, fragments });

const ADDMEMBERSHIPTOUSER_QUERY = `
  mutation addMembershipToUser($membershipId: Int!, $price: Float!, $membershipType: String!, $allInclusive: Boolean!, $startTime: DateTime, $endTime: DateTime, $membershipTypeIds: String, $sessionsCounter: Int, $reservationsCounter: Int, $userId: Int, $email: String, $customerId: Int, $paid: Float, $isPaid: Boolean, $method: String, $channel: String, $rules: String) {
    addMembershipToUser(membershipId: $membershipId, price: $price, membershipType: $membershipType, allInclusive: $allInclusive, startTime: $startTime, endTime: $endTime, membershipTypeIds: $membershipTypeIds, sessionsCounter: $sessionsCounter, reservationsCounter: $reservationsCounter, userId: $userId, email: $email, customerId: $customerId, paid: $paid, isPaid: $isPaid, method: $method, channel: $channel, rules: $rules)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const addMembershipToUserApiCall = async ({membershipId, price, membershipType, allInclusive, startTime, endTime, membershipTypeIds, sessionsCounter, reservationsCounter, userId, email, customerId, paid, isPaid, method, channel, rules}, fragments = null) => apiCall({ query: ADDMEMBERSHIPTOUSER_QUERY, variables: {membershipId, price, membershipType, allInclusive, startTime, endTime, membershipTypeIds, sessionsCounter, reservationsCounter, userId, email, customerId, paid, isPaid, method, channel, rules}, fragments });

const CHANGEUSERMEMBERSHIPSTATUS_QUERY = `
  mutation changeUserMembershipStatus($id: Int, $userId: Int, $isActive: Boolean, $customerId: Int) {
    changeUserMembershipStatus(id: $id, userId: $userId, isActive: $isActive, customerId: $customerId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const changeUserMembershipStatusApiCall = async ({id, userId, isActive, customerId}, fragments = null) => apiCall({ query: CHANGEUSERMEMBERSHIPSTATUS_QUERY, variables: {id, userId, isActive, customerId}, fragments });

const UPDATEORDERPAIDWITHMEMBERSHIP_QUERY = `
  mutation updateOrderPaidWithMembership($orderId: Int!, $membershipId: Int!) {
    updateOrderPaidWithMembership(orderId: $orderId, membershipId: $membershipId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateOrderPaidWithMembershipApiCall = async ({orderId, membershipId}, fragments = null) => apiCall({ query: UPDATEORDERPAIDWITHMEMBERSHIP_QUERY, variables: {orderId, membershipId}, fragments });

const REORDERMEMBERSHIP_QUERY = `
  mutation reorderMembership($oldPosition: Int!, $newPosition: Int!, $groupId: Int!) {
    reorderMembership(oldPosition: $oldPosition, newPosition: $newPosition, groupId: $groupId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const reorderMembershipApiCall = async ({oldPosition, newPosition, groupId}, fragments = null) => apiCall({ query: REORDERMEMBERSHIP_QUERY, variables: {oldPosition, newPosition, groupId}, fragments });

const REQUESTMEMBERSHIPCUSTOMER_QUERY = `
  mutation requestMembershipCustomer($membershipId: Int!, $startTime: DateTime!, $quantity: Int) {
    requestMembershipCustomer(membershipId: $membershipId, startTime: $startTime, quantity: $quantity)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const requestMembershipCustomerApiCall = async ({membershipId, startTime, quantity}, fragments = null) => apiCall({ query: REQUESTMEMBERSHIPCUSTOMER_QUERY, variables: {membershipId, startTime, quantity}, fragments });

const REQUESTBUNDLECUSTOMER_QUERY = `
  mutation requestBundleCustomer($bundleId: String!, $startTime: DateTime!) {
    requestBundleCustomer(bundleId: $bundleId, startTime: $startTime)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const requestBundleCustomerApiCall = async ({bundleId, startTime}, fragments = null) => apiCall({ query: REQUESTBUNDLECUSTOMER_QUERY, variables: {bundleId, startTime}, fragments });

const APPROVEUSERMEMBERSHIP_QUERY = `
  mutation approveUserMembership($userMembershipId: Int!) {
    approveUserMembership(userMembershipId: $userMembershipId)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const approveUserMembershipApiCall = async ({userMembershipId}, fragments = null) => apiCall({ query: APPROVEUSERMEMBERSHIP_QUERY, variables: {userMembershipId}, fragments });

const CREATEMEMBERSHIPRULE_QUERY = `
  mutation createMembershipRule($request: MembershipRuleInput!) {
    createMembershipRule(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const createMembershipRuleApiCall = async ({request}, fragments = null) => apiCall({ query: CREATEMEMBERSHIPRULE_QUERY, variables: {request}, fragments });

const ARCHIVEMEMBERSHIPRULE_QUERY = `
  mutation archiveMembershipRule($id: Int!) {
    archiveMembershipRule(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const archiveMembershipRuleApiCall = async ({id}, fragments = null) => apiCall({ query: ARCHIVEMEMBERSHIPRULE_QUERY, variables: {id}, fragments });

const UPDATEMEMBERSHIPRULE_QUERY = `
  mutation updateMembershipRule($request: MembershipRuleInput!) {
    updateMembershipRule(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateMembershipRuleApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATEMEMBERSHIPRULE_QUERY, variables: {request}, fragments });

const UPDATEUSERMEMBERSHIPRULES_QUERY = `
  mutation updateUserMembershipRules($id: Int!, $startTime: DateTime!, $endTime: DateTime!, $rules: String!) {
    updateUserMembershipRules(id: $id, startTime: $startTime, endTime: $endTime, rules: $rules)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateUserMembershipRulesApiCall = async ({id, startTime, endTime, rules}, fragments = null) => apiCall({ query: UPDATEUSERMEMBERSHIPRULES_QUERY, variables: {id, startTime, endTime, rules}, fragments });
